import { SET_AUTH } from '../actions/authAction';

const initialState = {
    isAuth: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case SET_AUTH:
            return { ...state, isAuth: action.auth };
        default:
            return state;
    }
}
